<template>
  <div class="sidebar">
    <div class="sidebar-content">
      <template v-if="show">
        <img class="logo" src="../assets/logo.png">
        <div class="item active">
          <router-link to="/">Home</router-link>
        </div>
        <div class="item active">
          <router-link to="/products">Products</router-link>
        </div>
        <div class="item active">
          <router-link to="/approvals">Approvals</router-link>
        </div>
        <div class="item">
          <router-link to="/graph">Graph</router-link>
        </div>
      </template>
      <div class="expander"></div>
      <button @click="$emit('toggle')">
        <i v-if="show" class="fas fa-chevron-circle-left"></i>
        <i v-else class="fas fa-chevron-circle-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: { show: Boolean },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.sidebar {
  grid-column: 1;
  grid-row: 1;
  background-color: #27282a;

  .sidebar-content {
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 10px;

    .logo {
      max-width: calc(100% - 20px);
      object-fit: contain;
      align-self: center;
    }

    .item {
      padding: 0.375em 0.75em;

      &:first-of-type { margin-top: 10px; }

      a { color: #a1a7ad; }

      &.active {
        a { color: white; }
      }
    }

    .expander { flex: 1 }

    button {
      align-self: flex-end;
    }
  }
}
</style>
